if (!customElements.get('description-tabs')) {
  class DescriptionTabs extends HTMLElement {
    constructor() {
      super();
      this.activeClass = 'is-active';
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.description-tabs__tab'));
      this.panels = Array.from(this.querySelectorAll('.description-tabs__panel'));

      if (!this.tabs.length || !this.panels.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onClick.bind(this, tab));
        tab.addEventListener('keydown', this.onKeydown);
      });

      this.activateDefault();
    }

    onClick(tab, event) {
      event.preventDefault();
      this.activate(tab, { focus: false });
    }

    onKeydown(event) {
      const tab = event.currentTarget;
      const currentIndex = this.tabs.indexOf(tab);
      if (currentIndex === -1) return;

      const lastIndex = this.tabs.length - 1;
      let targetIndex = -1;

      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          targetIndex = currentIndex === lastIndex ? 0 : currentIndex + 1;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          targetIndex = currentIndex === 0 ? lastIndex : currentIndex - 1;
          break;
        case 'Home':
          targetIndex = 0;
          break;
        case 'End':
          targetIndex = lastIndex;
          break;
        case 'Enter':
        case ' ':
        case 'Spacebar':
          event.preventDefault();
          this.activate(tab, { focus: false });
          return;
        default:
          return;
      }

      event.preventDefault();
      this.activate(this.tabs[targetIndex], { focus: true });
    }

    activate(tab, { focus = false } = {}) {
      if (!tab || tab.getAttribute('aria-selected') === 'true') {
        if (focus) tab.focus();
        return;
      }

      const tabIndex = tab.dataset.tabIndex;

      for (let i = 0, len = this.tabs.length; i < len; i++) {
        const current = this.tabs[i];
        const isActive = current === tab;
        current.classList.toggle(this.activeClass, isActive);
        current.setAttribute('aria-selected', isActive ? 'true' : 'false');
        current.setAttribute('tabindex', isActive ? '0' : '-1');
      }

      for (let i = 0, len = this.panels.length; i < len; i++) {
        const panel = this.panels[i];
        const isActive = panel.dataset.panelIndex === tabIndex;
        panel.classList.toggle(this.activeClass, isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }

      if (focus) tab.focus();
    }

    activateDefault() {
      const requested = parseInt(this.dataset.defaultIndex || '0', 10);
      const target = this.tabs[Number.isNaN(requested) ? 0 : requested] || this.tabs[0];
      if (target) this.activate(target, { focus: false });
    }
  }

  customElements.define('description-tabs', DescriptionTabs);
}
